import { useRef } from 'react';
import { AccessCodes } from '@pm2/api';
import { pm2SitemapStore, findResourcePageTree, findCourseDescriptorFromParents } from '@pm2/sitemap-utils';
import { pm2ConfigStore, pm2InterfaceStore } from '@pm2/store';
import { UserAreaLeftNav } from '@pm2/user-area';
import { useLocation } from '@provider/navigation';
import { Pill } from '@ui/kit';
import { PM2AppleIcon, BulbIcon } from '@ui/kit/icons';
import { Header } from './nav-header.js';
import { NavLayer } from './nav-layer.js';
import { Revisions } from './revisions.js';
import { subNavigationCls, pillsWrapper } from './sub-navigation.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function SubNavigation({
  pageDescriptor,
  currentPageDescriptor,
  onLinkClick
}) {
  const location = useLocation();
  const navRef = useRef(null);
  const sitemap = pm2SitemapStore.useSelector(state => state);
  const areCourseRevisionsEnabled = pm2ConfigStore.useSelector(state => state.config.settings.showCoursePlanner);

  // NB: The UserArea page is a special case wherein a custom subnavigation
  // must be rendered as it has custom layout rules. See ADO #133092
  if (pageDescriptor?.type === "UserArea") {
    return /*#__PURE__*/jsx(UserAreaLeftNav, {});
  }
  if (!pageDescriptor?.children?.length) {
    return null;
  }
  const handleToggleResources = () => {
    pm2InterfaceStore.dispatch(pm2InterfaceStore.actions.toggleResources(true));
  };
  const resourcePageTree = findResourcePageTree(sitemap, pageDescriptor);
  const courseDescriptor = findCourseDescriptorFromParents(sitemap, pageDescriptor);
  const teacherGuidePageDescriptor = courseDescriptor?.children?.find(it => it.type === "TeachersGuidePage");
  const isTeacherGuideCurrentPath = teacherGuidePageDescriptor?.path === location.pathname;
  const showTeacherGuideButton = !!teacherGuidePageDescriptor && teacherGuidePageDescriptor.accessCode === AccessCodes.ALLOWED;
  const showResourcesButton = resourcePageTree.length > 0;
  return /*#__PURE__*/jsxs("nav", {
    className: subNavigationCls,
    ref: navRef,
    children: [/*#__PURE__*/jsx(Header, {
      pageDescriptor: pageDescriptor
    }), areCourseRevisionsEnabled && courseDescriptor && /*#__PURE__*/jsx(Revisions, {
      currentPageDescriptor: currentPageDescriptor,
      courseDescriptor: courseDescriptor
    }), (showTeacherGuideButton || showResourcesButton) && /*#__PURE__*/jsxs("div", {
      className: pillsWrapper,
      children: [showTeacherGuideButton && /*#__PURE__*/jsx(Pill, {
        as: "a",
        active: isTeacherGuideCurrentPath,
        href: teacherGuidePageDescriptor.path,
        "aria-current": isTeacherGuideCurrentPath ? "page" : undefined,
        icon: /*#__PURE__*/jsx(PM2AppleIcon, {
          height: "20"
        }),
        size: "small",
        children: "Til l\xE6rer"
      }), showResourcesButton && /*#__PURE__*/jsx(Pill, {
        onClick: handleToggleResources,
        icon: /*#__PURE__*/jsx(BulbIcon, {
          height: "20"
        }),
        size: "small",
        children: "Ressourcer"
      })]
    }), /*#__PURE__*/jsx(NavLayer, {
      parentDescriptor: pageDescriptor,
      onLinkClick: onLinkClick
    })]
  });
}

export { SubNavigation };
//# sourceMappingURL=sub-navigation.js.map
